/**
 * Nome legível na UI — prioriza login real do painel e remove sufixo « XUI»
 * de importações antigas.
 */
export function resolveUserDisplayName(user, fallback = 'Conta') {
  if (!user) return fallback;
  const panel = String(user.xui_panel_username || '').trim();
  if (panel) return panel;
  const display = String(user.display_name || '').trim();
  if (display) return display;
  let name = String(user.name || '').trim();
  name = name.replace(/\s+XUI\s*$/i, '').trim();
  if (name) return name;
  const email = String(user.email || '').trim();
  if (email && email.includes('@')) return email.split('@')[0];
  return email || fallback;
}

/** A second, non-repeated identifier for the signed-in account. */
export function resolveUserSecondaryIdentity(user, primary = resolveUserDisplayName(user)) {
  const normalize = value => String(value || '').trim();
  const primaryKey = normalize(primary).toLocaleLowerCase();
  for (const value of [user?.name, user?.display_name]) {
    const name = normalize(value).replace(/\s+XUI\s*$/i, '').trim();
    if (name && name.toLocaleLowerCase() !== primaryKey
        && !/^(admin|administrador|administrator|atendente|attendant|revenda|reseller|conta)$/i.test(name)) return name;
  }
  const email = normalize(user?.email);
  return email.toLocaleLowerCase() === primaryKey ? '' : email;
}
